import React from 'react'

const SCADA = () => {
    return (
        <div>
            <section class="inner-banner">
                <div class="thm-container">
                    <h2> Product Details </h2>
                    <div class="breadcumb">
                        <a href="/">Automation Solution</a>
                        <i class="fa fa-angle-right"></i>
                        <span>Industrial Solution</span>
                        <i class="fa fa-angle-right"></i>
                        <span>SCADA</span>
                    </div>
                </div>
            </section>
            <div className='container py-4'>
                <div className='row d-flex' style={{ margin: "80px 0px" }}>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <img src='/img/scada.jpg' width={400}></img>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
                        <h2 style={{ textDecoration: "underline" }}>SCADA (Supervisory Control and Data Acquisition) Systems:</h2>
                        <p className="mbot25">
                            Our SCADA systems provide comprehensive monitoring and control of industrial processes.
                            With real-time data collection and analysis, you can optimize performance, reduce downtime,
                            and improve decision-making.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SCADA
